export enum AccServiceFamilyEnum {
    SERVICES_HOTELIERS = "SERVICES_HOTELIERS",
    VOS_PRESTATIONS = "VOS_PRESTATIONS",
    TRANSPORT = "TRANSPORT",
    RESTAURATION = "RESTAURATION",
    ACTIVITES_SPA_AND_BIENETRE = "ACTIVITES_SPA_AND_BIENETRE",
    PASS_MULTI_ACTIVITES = "PASS_MULTI_ACTIVITES",
    PARC_A_THEME = "PARC_A_THEME",
    BAGAGERIE = "BAGAGERIE",
    PARKING = "PARKING",
    CYCLING = "CYCLING",
    TRANSFERT = "TRANSFERT",
}

export enum PaymentConditions {
    Flex = 1,
    Fixe = 2
}

export enum WiypEntryPoint {
    INIT_PRICES = "init-prices",
    SELECT_SERVICES = "select-services",
    GET_PAYMENTS = "get-payments-v2",
    GET_QUOTE = "get-quote",
    VERIFY_PROMOCODE = "verify-promocode",
    STORE_CALCULATION = "store-calculation"
}

